export * from './resources-saurus-gestao';
export * from './resources-menu-vip';
export * from './resources-s2-pay';
export * from './interface-resources';

